module.exports = __webpack_public_path__ + "img/blurry-small-cartoon-crop.e0015576.jpg";